import { render, staticRenderFns } from "./MamWalletInternalTransferForm.vue?vue&type=template&id=663b6277&scoped=true"
import script from "./MamWalletInternalTransferForm.vue?vue&type=script&lang=js"
export * from "./MamWalletInternalTransferForm.vue?vue&type=script&lang=js"
import style0 from "./MamWalletInternalTransferForm.vue?vue&type=style&index=0&id=663b6277&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663b6277",
  null
  
)

export default component.exports